import { DynamicStandaloneTag, DynamicStandaloneTagProps } from '@/components/Tag';
import { componentTheme } from '@/styles/TagsIndex';
import { StandaloneComponent } from '@/types/component';
import mergeProps from 'lib/utils/mergeProps';

export type TagsIndexTagProps = DynamicStandaloneTagProps;

export const TagsIndexTagComponent: StandaloneComponent<TagsIndexTagProps> = (props) => {
  return (
    <DynamicStandaloneTag
      {...mergeProps(
        {
          options: {
            theme: componentTheme('tag'),
          },
        },
        props
      )}
    />
  );
};
